import {
  buildEmployeeAmountPipeline,
  buildPayrollAmountLookups,
  sumNumberOrArray,
} from "./shared";

const OVERPAYMENT_SUM = {
  $add: [
    sumNumberOrArray("$overpayment"),
    sumNumberOrArray("$overpaymentBasic"),
    sumNumberOrArray("$overpaymentPeraAda"),
  ],
};

export const OVERPAYMENT_LOOKUPS = buildPayrollAmountLookups(
  "overpayment",
  "overPayment",
  OVERPAYMENT_SUM,
);

export function getOverpaymentByEmployeePipeline(employeeIds = []) {
  return buildEmployeeAmountPipeline(
    employeeIds,
    "overPayment",
    OVERPAYMENT_SUM,
  );
}
